const passions = 'Agriculture;Farming;Sustainability;Creative Arts;Animation;Architecture;Fine Art;Fashion Design;Graphic Design;Illustration;Photography;Aviation; Business/Entrepreneurship;Accounting;Business;Entrepreneurship;Finance;PR;Marketing/Advertising;Beauty & Fashion;Cosmetology;Fashion;Community Service; Communications;Journalism;Linguistics;ASL;Criminal Justice;Pre-Law;Culinary Arts;Education;Special Education;Engineering;Aerospace Engineering;Biomedical Engineering; Chemical Engineering;Civil Engineering;Electrical Engineering;Mechanical Engineering;Petroleum Engineering;Software Engineering;Systems Engineering;Film; Television Production;Hospitality;Health and Fitness;Humanities/Social Science;Psychology/Sociology;International Relations;Religious Studies;History; Political Science;Mathematics;Statistics;Medicine;Dentistry;Nursing;Pharmacy;Physical Therapy;Veterinary Care;Music;Performance Art;Acting;Dancing;Singing;Science; Animal Science;Biology;Marine Biology;Chemistry;Food Science;Environmental Science;Social Services;Social Work;Therapist;Sports;Sports Management;E Sports; Technology;Computer Science;Game Design;IT;Cyber Security'.split(';');
export const passionData = () => {
	let options = [];

	for (let i = 0; i < passions.length; i++) {
		options.push({
			label: `${passions[i]}`, value: passions[i]
		});
	}

	return options
}

const majors = 'Aeronautics;Agribusiness;Agriculture;Animal Science;Animation;Architecture;Art;Aviation;Biochemistry;Botany;Business;Chemistry;Civil Engineering;Computer Science;Construction Management;Creative Writing;Criminal Justice;Culinary Arts;Dentistry;Economics;Education;Engineering;English Literature;Environmental Science;Environmental Studies;Finance;Geology;Gerontology;Health Sciences;Hematology;History;Horticulture;Humanities;International Law;International Studies;Kinesiology;Landscape Architecture;Landscaping;Language;Law;Liberal Arts;Marketing;Mathematics;Medicine;Music;Nursing;Oncology;Performing Arts;Pharmacy;Physics;Poetry;Pre-Law;Pre-Medicine;Psychology;Science;Social Science;Social Work;Special Education;STEM;Teaching;Unspecified;Vocational;Art Animation;Political Science;Computer Engineering;Environmental Science, Biology, Design;Environmental Science and Biology;Symbolic Systems (Computer Science);Biomolecular Science;Pre-med;Hydrogeology;Communications/Journalism;Math, Spanish;Chemical Engineering;Elementary Education;Mechanical Engineering;Microbiology;Business Management or Information Technology;Excercise Science;Ecology, Evolution, and Biodiversity (EEB);Aviation Flight Science;Entrepenurialship and Management;business management;pre-medical studies;Wildlife Science;Journalism;Sports Communication;communications;Critical Comunications and Media Studies;genetics;Undecided;Veterinary Sciences or Communications;Environmental science and OT;Biology;Bachelor of Science in Nursing;Food Marketing;Actuarial Mathematics;Art Education;French Language/Dance Performance;Film / Video / Animation;Visual/Studio Art;Journalism or Communications;Film and video;Theatre;Digital Art & Media;Sciences;Organizational Management;Accountancy;International Relations;cyber security;Pre-Physical Therapy;Forensic Science;General Psychology;Business Administration/Sports Management;Sport Management;Pediatric Nursing;Heating Ventilation Air Conditioning;Actuarial math and data science;Secondary Education/ Reading Specialty/ English;History and Pre Law;entrepreneurship;Biomedical Science;Exercise Science;Music Composition or Pre-law/Communications;Sports Business Management;Human Resource Management;Veterinary Medicine;Nursing, Associate of Applied Science program.;Pre Medicine;Veterinary Technology;Exercise Science/Kinesiology;Financial Analytics/Statistics;Welding Technologies;Global Studies in the Arts and Humanities;Bachelor of Science- Chemistry;Forensic Science/Criminal Justice;Egineering and Film, Video and Media Studies;Philosophy or Psychology;Biology/Pre-Pharmacy;Law Enforcement;Biomedical Engineering;Digital Media - Film and Digital Media;Behavioral Neuroscience/ Biopsychology;Graphic Design;Business in Sports Management;Business Administration;Political Science, Economics, and Geography;Pre med;Industrial engineering;Advertising;Biology (Forensic Science concentration);Digital Animation and Game Design;music eduication;Occupational Therapy;Linguistics;Criminal Justice and Psychology;Construction Engineering;Music Therapy;Pre-Occupational Therapy;Health, Society, and Biology;Legal Studies and Criminal Justice;Environmental Engineering;Global and International Studies;International Affairs & Relations;Integrated Supply Management & Business Analytics;Electrician Technology;Neuroscience;Zoology;Electrical Engineering & Computer Science (EECS);Aerospace Engineering;Biomedical Laboratory Science;Art/Elementary Education;BioMed;Secondary Education: English, Social Studies;Arts Management;Accounting;Interior Design;Psychology (BS);International Business;Medical Social Work;Anesthesiology;Biomedical Sciences;Natural Resource Management;Biological Sciences: Health Science;Multi-Media Art;Multi-Media/Video;Information Systems;Aviation Technical Operations;Music Education;Lyman Briggs/Biology;Biology, environmental/sustainability;Automotive;Marketing & Spanish;Art History;Human Biology;Science/medicine;High school English education and journalism;Fashion Merchandising;Radiology;Civil Engineering and fine arts;Actuarial Sciences and Accounting;Human Resources Management;Supply Chain;Financial Services;Pastoral Ministries;Audio Video Production;Biology and Computer Science;Sports Management;Meteorology;Pre Health Professions;Communication and Media;Psychology: Behavioral Science and Spanish;Nutrition;Composition;Game Design and Development;Biology Pre-Med;Physical Therapy;Biological Laboratory Science;Personal finance;Biochem;Global Health;English;Nursing RN;Other;Technology'.split(';');
export const majorsData = () => {
	let options = [];

	for (let i = 0; i < majors.length; i++) {
		options.push({
			label: `${majors[i]}`, value: majors[i]
		});
	}

	return options
}

// List values for identity visibility
export const IdentityVisibilityFields = ["Last_Name__c", "First_Name__c", "Email__c", "Email", "Email_Address__c"]

// TODO: Determine passion list
export const passionList = ["Agriculture", "Farming", "Sustainability", "Creative Arts", "Animation", "Architecture", "Fine Art", "Fashion Design", "Graphic Design", "Illustration", "Photography", "Aviation", " Business/Entrepreneurship", "Accounting", "Business", "Entrepreneurship", "Finance", "PR", "Marketing/Advertising", "Beauty & Fashion", "Cosmetology", "Fashion", "Community Service", " Communications", "Journalism", "Linguistics", "ASL", "Criminal Justice", "Pre-Law", "Culinary Arts", "Education", "Special Education", "Engineering", "Aerospace Engineering", "Biomedical Engineering", " Chemical Engineering", "Civil Engineering", "Electrical Engineering", "Mechanical Engineering", "Petroleum Engineering", "Software Engineering", "Systems Engineering", "Film", " Television Production", "Hospitality", "Health and Fitness", "Humanities/Social Science", "Psychology/Sociology", "International Relations", "Religious Studies", "History", " Political Science", "Mathematics", "Statistics", "Medicine", "Dentistry", "Nursing", "Pharmacy", "Physical Therapy", "Veterinary Care", "Music", "Performance Art", "Acting", "Dancing", "Singing", "Science", " Animal Science", "Biology", "Marine Biology", "Chemistry", "Food Science", "Environmental Science", "Social Services", "Social Work", "Therapist", "Sports", "Sports Management", "E Sports", " Technology", "Computer Science", "Game Design", "IT", "Cyber Security"]

// TODO: Determine other year options
export const yearList = [].concat(Array(35).fill(1990).map((x, y) => x + y));

// TODO: Determine other semester options
export const semesterList = ["Fall", "Spring", "Summer", "Winter", "Mid Year", "Year End"]
export const tagsWithUrl = ["a", "img", "iFrame"]
export const urlAttr = ['src', "href"]
export const allowedAttributes={
	a: ['href', 'name', 'target'],
	img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
	'*': ['style', "align", "border", "cellpadding", "cellspacing", "id"],
	iframe: ['src', "width", "height", "title", "frameborder", "allow", "allowfullscreen"],
}
export const allowedIframeHostnames = ['www.youtube.com', 'www.loom.com', 'player.vimeo.com'];
// TODO: Determine other university options
export const universityList = ["Ancilla College", "Anderson University", "Ball State University", "Bethel College", "Butler University", "Calumet College of Saint Joseph", "Chamberlain University", "DePauw University", "Earlham College", "Franklin College", "Goshen College", "Grace College", "Hanover College", "Holy Cross College", "Huntington University", "Indiana State University", "Indiana Tech", "Indiana University Bloomington", "Indiana University East", "Indiana University Fort Wayne (IUFW)", "Indiana University Kokomo", "Indiana University Northwest", "Indiana University South Bend", "Indiana University Southeast", "Indiana Wesleyan National & Global", "Indiana Wesleyan University", "Indiana University Purdue University Columbus", "Indiana University Purdue University Indianapolis (IUPUI)", "Ivy Tech", "Manchester University", "Marian University", "Martin University", "Oakland City University", "Purdue Fort Wayne", "Purdue Global", "Purdue University West Lafayette", "Purdue University North Central", "Purdue University Northwest", "Rose-Hulman", "Saint Mary's of the Woods", "Saint Mary's College", "Taylor University", "Trine University", "University of Evansville", "University of Indianapolis", "University of Notre Dame", "University of Saint Francis", "University of Southern Indiana", "Valparaiso University", "Vincennes University", "Wabash College", "Walden University", "WGU"]

// TODO: Determine other draft options
export const draftForApplicationTab = ["Draft"]

export const allForApplicationTab = [
	"Applicants Notified of Award",
	"Applicants Notified of Interview",
	"Approved",
	"Awarded Stage",
	"Awarded-Declined",
	"Complete",
	"Decline",
	"Declined",
	"Declined Stage",
	"Deferred",
	"Draft",
	"Early Eligibility Review",
	"Eligible Applicant Pool",
	"Finalist",
	"General Eligibility Review",
	"Incomplete",
	"Ineligible",
	"Ineligible Stage",
	"In Review Board",
	"Interview",
	"Interview Stage",
	"Not Renewed",
	"Not Selected",
	"Paid",
	"Past Cycle",
	"Preliminary Finalist",
	"Prototype",
	"Rejected",
	"Rejected Award",
	"Renewed",
	"Review Board Submitted",
	"Selected",
	"Sent",
	"Sent with Tracking",
	"Shortlist",
	"Submitted",
	"Under Eligibility Review",
	"Under Review",
	"Waitlisted",
	"Winner",
	"Withdrawn",
	"Withdrawn Stage",
	"Unqualified",
	"Pending Client Action",
	"Unconcluded",
	"Pending",
	"Need Additional Information",
	"Accepted",
	"Alternate",
	"Committee Recommendation",
	"Qualified",
	"Pending Contributor Submissions"
]

// TODO: Determine other submitted options
export const completedForApplicationTab = ["Submitted", "Pending Contributor Submissions"]

//  For the Application Status Percentage 
export const completeStatusShow = ['Draft', 'Incomplete']

// New Updated Application Subtext

export const scholarshipStatusData = {
	"Applicants Notified of Award": "View your",
	"Applicants Notified of Interview": "View your",
	"Approved": "View your",
	"Complete": "View your",
	"Draft": "Click Here to Finish",
	"Finalist": "View your",
	"Ineligible": "View your",
	"In Review Board": "View your",
	"Not Selected": "View your",
	"Past Cycle": "View your",
	"Preliminary Finalist": "View your",
	"Prototype": "Click Here to Finish",
	"Rejected": "View your",
	"Review Board Submitted": "View your",
	"Selected": "View your",
	"Shortlist": "View your",
	"Submitted": "View your",
	"Under Eligibility Review": "View your",
	"Under Review": "",
	"Waitlisted": "View your",
	"Winner": "View your",
	"Withdrawn": "View your",
	"Awarded Stage": "View your",
	"Decline": "View your ",
	"Declined": "View your",
	"Declined Stage": "View your",
	"Early Eligibility Review": "View your",
	"Eligible Applicant Pool": "View your",
	"General Eligibility Review": "View your",
	"Incomplete": "Click Here to Finish",
	"Ineligible Stage": "View your",
	"Interview": "View your",
	"Interview Stage": "View your",
	"Not Renewed": "View your",
	"Paid": "View your",
	"Rejected Award": "View your",
	"Renewed": "View your",
	"Sent": "View your",
	"Sent with Tracking": "View your",
	"Withdrawn Stage": "View your",
	"Unqualified": "View your",
	"Pending Client Action": "View your",
	"Deferred": "View your",
	"Qualified": "View your",
	"Accepted": "View your",
	"Alternate": "View your",
	"Committee Recommendation": "View your",

}

export const scholarshipMainTextData = {
	"Applicants Notified of Award": "In review",
	"Applicants Notified of Interview": "",
	"Approved": "Approved",
	"Complete": "Complete",
	"Draft": "In progress",
	"Finalist": "In review",
	"Ineligible": "Ineligible",
	"In Review Board": "In review",
	"Not Selected": "Not selected",
	"Past Cycle": "Past Cycle",
	"Preliminary Finalist": "In review",
	"Prototype": "Testing",
	"Rejected": "Not selected",
	"Review Board Submitted": "In review",
	"Selected": "Awarded",
	"Shortlist": "In review",
	"Submitted": "Submitted",
	"Under Eligibility Review": "In review",
	"Under Review": "In review",
	"Waitlisted": "In review",
	"Winner": "Awarded",
	"Withdrawn": "Withdrawn",
	"Awarded Stage": "Awarded",
	"Decline": "Not selected",
	"Declined": "Not selected",
	"Declined Stage": "Not selected",
	"Deferred": "Deferred",
	"Early Eligibility Review": "In review",
	"Eligible Applicant Pool": "Eligible Applicant Pool",
	"General Eligibility Review": "In review",
	"Incomplete": "Incomplete",
	"Ineligible Stage": "Ineligible",
	"Interview": "Interview",
	"Interview Stage": "Interview Stage",
	"Not Renewed": "Not Renewed",
	"Paid": "Awarded",
	"Rejected Award": "Rejected Award",
	"Renewed": "Renewed",
	"Sent": "Sent",
	"Sent with Tracking": "Sent with Tracking",
	"Withdrawn Stage": "Withdrawn",
	"Unqualified": "Ineligible",
	"Pending Client Action": "",
	"Qualified": "Qualified",
	"Accepted": "Accepted",
	"Alternate": "Alternate",
	"Committee Recommendation": "Committee Recommendation",
	"Pending Contributor Submissions": "Pending Contributor Submissions"
}

export const userMessageStatusArr = ["Incomplete", "Draft", "Prototype"]
export const elementsSubmmitedAppStatus = ["Pending Contributor Submissions", "Complete"]
export const pastForApplicationTab = ["Draft", "Incomplete"]
export const recQuestionAwardBuilder = ["First Name", "Last Name", "Email", "Relationship", "Message"]

export const draft = ['Draft', "Prototype"]

// TODO: Determine other completed options
export const completed = ['Submitted', 'In Review Board']

// Question Type in award Builder

export const questionTypes = ["Roll Up Iterations", "Formula"]

// TODO: Determine other past options, "Incomplete" remove this "Archived",
export const past = ["Ineligible", "Not Selected", "Preliminary Finalist", "Rejected", "Winner", "Under Review", "Approved", "Selected", "Withdrawn", "Complete", "Review Board Submitted", "Finalist", "Waitlisted", "Under Eligibility Review", "Reviewed", "Deferred", "Applicants Notified of Award", "Applicants Notified of Interview", "4 Year Eligible", "Shortlist", "Past Cycle"]

// TODO: Determine scholarship status options "Review Board", "Accepting Applicants",
export const scholarshipStatusList = ["Draft", "Accepting Applications", "Review Board", "Under Review", "Closed"]

// TODO: Determine scholarship TimeZone options",
export const usaTimeZoneList = ["America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles", "America/Phoenix", "America/Anchorage", "Pacific/Honolulu"]

export const applicationStatus = ["Applicants Notified of Award", "Applicants Notified of Interview", "Draft", "Prototype", "Withdrawn", "Submitted", "Under Eligibility Review", "In Review Board", "Review Board Submitted", "Rejected", "Winner", "Ineligible", "Incomplete", "Preliminary Finalist", "Finalist", "Archived", "Approved", "Waitlisted", "Under Review", "Interview", "Selected", "Not Selected", "Deferred", "Past Cycle", "Complete", "Shortlist", "Unqualified", "Qualified", "Accepted", "Alternate", "Committee Recommendation"]

// TODO: Determine other degree options
export const degreeList = ["Certificate", "Associate Degree", "Bachelor's Degree", "Master's Degree"]

// TODO: Determine other Gallagher Country options
export const gallagherCountryList = ["Mexico", "South Africa", "Turkey"]

// TODO: Determine other Gallagher Term options
export const gallagherTermList = ["Semester 1", "Semester 2"]

// TODO: Determine other gallagher status color options
export const statusColorList = ['Green', 'Red', 'Yellow']

// TODO: Determine other Academic Year/Term options
export const AcademicYearTermList = ["2020-21 1/Fall", "2020-21 2/Winter", "2020-21 3/Spring", "2020-21 4/Summer", "2019-2020 Academic Year", "2019-20 2/Winter", "2019-20 3/Spring", "2019-20 4/Summer", "2019-20 1/Fall", "2018-19 1/Fall", "2018-19 2/Winter", "2018-19 3/Spring", "2018-2019 Academic Year", "2018-19 4/Summer", "2017-18 1/Fall", "2017-18 2/Winter", "2017-18 3/Spring", "2017-18 4/Summer", "2016-17 1/Fall", "2016-17 2/Winter", "2016-17 3/Spring", "2016-17 4/Summer", "2015-16 4/Summer", "2015-16 3/Spring", "2015-16 2/Winter", "2015-16 1/Fall", "2014-15 4/Summer", "2014-15 3/Spring", "2014-15 2/Winter", "2014-15 1/Fall", "2013-14 4/Summer", "2013-14 3/Spring", "2013-14 2/Winter", "2013-14 1/Fall", "2012-13 4/Summer", "2012-13 3/Spring", "2012-13 2/Winter", "2012-13 1/Fall", "2011-12 4/Summer", "2011-12 3/Spring", "2011-12 2/Winter", "2011-12 1/Fall", "2010-11 4/Summer", "2010-11 3/Spring", "2010-11 2/Winter", "2010-11 1/Fall", "2009-10 4/Summer", "2009-10 3/Spring", "2009-10 2/Winter", "2009-10 1/Fall", "2008-09 4/Summer", "2008-09 3/Spring", "2008-09 2/Winter", "2008-09 1/Fall", "2007-08 4/Summer", "2007-08 3/Spring", "2007-08 2/Winter", "2007-08 1/Fall", "2006-07 4/Summer", "2006-07 3/Spring", "2006-07 2/Winter", "2006-07 1/Fall", "2005-06 4/Summer", "2005-06 3/Spring", "2005-06 2/Winter", "2005-06 1/Fall", "2004-05 4/Summer", "2004-05 3/Spring"]

// TODO: Determine other fund status options
export const fundStatusList = ["Conditioned", "Funded", "Not Funded", "Suspended"]

// TODO: Determine other hsg_status_by_staff options
export const hsgStatusByStaffList = ["Progress", "Final", "Entered by student"]

// TODO: Determine other i_was_employed options
export const iWasEmployedList = ["I did not work this term", "I worked 0-10 hrs/wk", "I worked 10-20 hrs/wk", "I worked 20-30 hrs/wk", "I worked 30-40 hrs/wk", "I worked over 40 hrs/wk"]

// TODO: Determine other i_worked_at_an_internship options
export const iWorkedAtAnInternshipList = ["No, I did not work at an internship during this term", "Yes, I interned and worked 0-10 hrs/week", "Yes, I interned and worked 10-20 hrs/week", "Yes, I interned and worked 20-30 hrs/week", "Yes, I interned and worked 30-40 hrs/week"]

// TODO: Determine other my_employment_qualified_as_work_study options
export const myEmploymentQualifiedAsWorkStudyList = ["Yes, my employment only qualified as Work Study", "Yes, my employment qualified as Work Study and I also earned wages outside of Work Study", "No, I did not work as part of a Work Study program", "I did not work this term"]

// TODO: Determine other terms options
export const termsList = ["Fresh Term 1", "Fresh Term 2", "Soph Term 1", "Soph Term 2", "Jr Term 1", "Jr Term 2", "Sr Term 1", "Sr Term 2", "Fresh Summer", "Soph Summer", "Jr Summer", "Sr Summer"]

// TODO: Determine other participation options
export const participationList = ['Yes, I tend to participate in the Questa Scholar Program', 'No, I do not intend to participate in the Questa Scholar Program']

// TODO: Determine other Yes/No options
export const radioDefaultList = ["Yes", "No"]

// TODO: Determine other gender options
export const genderList = ['Male', 'Female', 'Gender Variant/Non-Conforming', "Other", 'Prefer Not to Respond', 'Transgender Male', 'Transgender Female']

// TODO: Determine other race ethinicity options
export const raceEthinicityList = ['Asian', 'Black or African American', 'Some other race, ethnicity or origin', 'White', 'Hispanic, Latino or Spanish Origin', 'American Indian or Alaska Native', 'Middle Eastern or North African', 'Pacific Islander', 'Unknown', 'Do Not Want to Report']

// TODO: Determine other toco bell position  options
export const tacoBellPostion = ['Assistant Manager', 'Food Champion', 'General Manager', 'Service Champion', 'Shift Lead', 'Trainer']

// TODO: Determine other Post Secondary Degree options
export const postSecondaryDegreeList = ['Associate of Arts (AA)', 'Associate of Science (AS)', 'Bachelor of Arts (BA)', 'Bachelor of Science (BS)', 'Certificate or Diploma', 'Doctorate Degree (PhD)', 'Graduate or Professional', "Master's Degree", 'Other', 'Trade or Technical Certificate or License', 'Undecided', 'Bachelor Degree', 'Associate Degree', 'Certification', 'Licensure']

// TODO: Determine other Secondary School Degree options
export const secondarySchoolDegreeList = ['General Equivalency Diploma (GED)', 'High School Diploma', 'Honors Diploma', 'Other', 'International Baccalaureate (IB) Diploma']

// TODO: Determine other classes options
export const classesList = ['None', '1-3', '4-6', '7-8', '9 or more']

// TODO: Determine other post options
export const postList = ['Assistant Manager', 'Food Champion', 'General Manager', 'Service Champion', 'Shift Lead', 'Trainer']

// TODO: Determine other financial Visibility options
export const financialVisibilityList = ['fafsa_completed', 'pell_grant_eligibility', 'pell_grant_amount']

// TODO: Determine other score visibility options
export const scoreVisibilityList = ['act_score', 'psat_composite_score', 'sat_score']

// TODO: Determine other applicant profile Field List options
export const profileFieldList = ['grade_level', 'school_name', 'gender', 'race_ethinicity', 'taco_bell_position__c', 'post_secondary_degree__c', 'post_secondary_graduation_year__c', 'secondary_school_degree__c', 'still_employed_by_taco_bell__c', 'smagicinteract__smsoptout__c', 'pell_grant_eligibility__c', 'country', 'state', 'city']

// TODO: Determine hide sidebar for applicant options
export const hideSidebarApplicantList = ['APPLICATIONS', 'RESET_PASSWORD', 'SSO_AUTHENTICATION', 'CALLBACK']

// TODO: Determine data types
export const dataTypeApplicationBuilder = [
	{
		"label": "Checkbox",
		"value": "Checkbox"
	},
	{
		"label": "Document",
		"value": "Document"
	},
	{
		"label": "Video",
		"value": "Video"
	},
	{
		"label": "Currency",
		"value": "Currency"
	},
	{
		"label": "Date",
		"value": "Date"
	},
	{
		"label": "Date(Date-Month-Year)",
		"value": "Date(Date-Month-Year)"
	},
	{
		"label": "Date(Month-Year)",
		"value": "Date(Month-Year)"
	},
	{
		"label": "Date(Year)",
		"value": "Date(Year)"
	},
	{
		"label": "Email",
		"value": "Email"
	},
	{
		"label": "Long Text",
		"value": "Long Text"
	},
	{
		"label": "Multiselect Picklist",
		"value": "Multiselect Picklist"
	},
	{
		"label": "Number",
		"value": "Number"
	},
	{
		"label": "Output Message",
		"value": "Output Message"
	},
	{
		"label": "Phone",
		"value": "Phone"
	},
	{
		"label": "Picklist",
		"value": "Picklist"
	},
	{
		"label": "Radio Button",
		"value": "Radio Button"
	},
	{
		"label": "Signature",
		"value": "Signature"
	},
	{
		"label": "Signature With Timestamp",
		"value": "Signature With Timestamp"
	},
	{
		"label": "Text",
		"value": "Text"
	}
];

// list of currency symbol with country name and currency name 
export const currencySymbolList = {
	"USD": {
		"symbol": "$",
		"name": "US Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "USD",
		"name_plural": "US dollars"
	},
	"CAD": {
		"symbol": "CA$",
		"name": "Canadian Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "CAD",
		"name_plural": "Canadian dollars"
	},
	"EUR": {
		"symbol": "€",
		"name": "Euro",
		"symbol_native": "€",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "EUR",
		"name_plural": "euros"
	},
	"AED": {
		"symbol": "AED",
		"name": "United Arab Emirates Dirham",
		"symbol_native": "د.إ.‏",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "AED",
		"name_plural": "UAE dirhams"
	},
	"AFN": {
		"symbol": "Af",
		"name": "Afghan Afghani",
		"symbol_native": "؋",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "AFN",
		"name_plural": "Afghan Afghanis"
	},
	"ALL": {
		"symbol": "ALL",
		"name": "Albanian Lek",
		"symbol_native": "Lek",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "ALL",
		"name_plural": "Albanian lekë"
	},
	"AMD": {
		"symbol": "AMD",
		"name": "Armenian Dram",
		"symbol_native": "դր.",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "AMD",
		"name_plural": "Armenian drams"
	},
	"ARS": {
		"symbol": "AR$",
		"name": "Argentine Peso",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "ARS",
		"name_plural": "Argentine pesos"
	},
	"AUD": {
		"symbol": "AU$",
		"name": "Australian Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "AUD",
		"name_plural": "Australian dollars"
	},
	"AZN": {
		"symbol": "man.",
		"name": "Azerbaijani Manat",
		"symbol_native": "ман.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "AZN",
		"name_plural": "Azerbaijani manats"
	},
	"BAM": {
		"symbol": "KM",
		"name": "Bosnia-Herzegovina Convertible Mark",
		"symbol_native": "KM",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BAM",
		"name_plural": "Bosnia-Herzegovina convertible marks"
	},
	"BDT": {
		"symbol": "Tk",
		"name": "Bangladeshi Taka",
		"symbol_native": "৳",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BDT",
		"name_plural": "Bangladeshi takas"
	},
	"BGN": {
		"symbol": "BGN",
		"name": "Bulgarian Lev",
		"symbol_native": "лв.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BGN",
		"name_plural": "Bulgarian leva"
	},
	"BHD": {
		"symbol": "BD",
		"name": "Bahraini Dinar",
		"symbol_native": "د.ب.‏",
		"decimal_digits": 3,
		"rounding": 0,
		"code": "BHD",
		"name_plural": "Bahraini dinars"
	},
	"BIF": {
		"symbol": "FBu",
		"name": "Burundian Franc",
		"symbol_native": "FBu",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "BIF",
		"name_plural": "Burundian francs"
	},
	"BND": {
		"symbol": "BN$",
		"name": "Brunei Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BND",
		"name_plural": "Brunei dollars"
	},
	"BOB": {
		"symbol": "Bs",
		"name": "Bolivian Boliviano",
		"symbol_native": "Bs",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BOB",
		"name_plural": "Bolivian bolivianos"
	},
	"BRL": {
		"symbol": "R$",
		"name": "Brazilian Real",
		"symbol_native": "R$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BRL",
		"name_plural": "Brazilian reals"
	},
	"BWP": {
		"symbol": "BWP",
		"name": "Botswanan Pula",
		"symbol_native": "P",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BWP",
		"name_plural": "Botswanan pulas"
	},
	"BYN": {
		"symbol": "Br",
		"name": "Belarusian Ruble",
		"symbol_native": "руб.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BYN",
		"name_plural": "Belarusian rubles"
	},
	"BZD": {
		"symbol": "BZ$",
		"name": "Belize Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "BZD",
		"name_plural": "Belize dollars"
	},
	"CDF": {
		"symbol": "CDF",
		"name": "Congolese Franc",
		"symbol_native": "FrCD",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "CDF",
		"name_plural": "Congolese francs"
	},
	"CHF": {
		"symbol": "CHF",
		"name": "Swiss Franc",
		"symbol_native": "CHF",
		"decimal_digits": 2,
		"rounding": 0.05,
		"code": "CHF",
		"name_plural": "Swiss francs"
	},
	"CLP": {
		"symbol": "CL$",
		"name": "Chilean Peso",
		"symbol_native": "$",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "CLP",
		"name_plural": "Chilean pesos"
	},
	"CNY": {
		"symbol": "CN¥",
		"name": "Chinese Yuan",
		"symbol_native": "CN¥",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "CNY",
		"name_plural": "Chinese yuan"
	},
	"COP": {
		"symbol": "CO$",
		"name": "Colombian Peso",
		"symbol_native": "$",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "COP",
		"name_plural": "Colombian pesos"
	},
	"CRC": {
		"symbol": "₡",
		"name": "Costa Rican Colón",
		"symbol_native": "₡",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "CRC",
		"name_plural": "Costa Rican colóns"
	},
	"CUP": {
		"symbol": "MN$",
		"name": "Cuban peso",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "CUP",
		"name_plural": "Cuban pesos"
	},
	"CVE": {
		"symbol": "CV$",
		"name": "Cape Verdean Escudo",
		"symbol_native": "CV$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "CVE",
		"name_plural": "Cape Verdean escudos"
	},
	"CZK": {
		"symbol": "Kč",
		"name": "Czech Republic Koruna",
		"symbol_native": "Kč",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "CZK",
		"name_plural": "Czech Republic korunas"
	},
	"DJF": {
		"symbol": "Fdj",
		"name": "Djiboutian Franc",
		"symbol_native": "Fdj",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "DJF",
		"name_plural": "Djiboutian francs"
	},
	"DKK": {
		"symbol": "Dkr",
		"name": "Danish Krone",
		"symbol_native": "kr",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "DKK",
		"name_plural": "Danish kroner"
	},
	"DOP": {
		"symbol": "RD$",
		"name": "Dominican Peso",
		"symbol_native": "RD$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "DOP",
		"name_plural": "Dominican pesos"
	},
	"DZD": {
		"symbol": "DA",
		"name": "Algerian Dinar",
		"symbol_native": "د.ج.‏",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "DZD",
		"name_plural": "Algerian dinars"
	},
	"EEK": {
		"symbol": "Ekr",
		"name": "Estonian Kroon",
		"symbol_native": "kr",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "EEK",
		"name_plural": "Estonian kroons"
	},
	"EGP": {
		"symbol": "EGP",
		"name": "Egyptian Pound",
		"symbol_native": "ج.م.‏",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "EGP",
		"name_plural": "Egyptian pounds"
	},
	"ERN": {
		"symbol": "Nfk",
		"name": "Eritrean Nakfa",
		"symbol_native": "Nfk",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "ERN",
		"name_plural": "Eritrean nakfas"
	},
	"ETB": {
		"symbol": "Br",
		"name": "Ethiopian Birr",
		"symbol_native": "Br",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "ETB",
		"name_plural": "Ethiopian birrs"
	},
	"GBP": {
		"symbol": "£",
		"name": "British Pound Sterling",
		"symbol_native": "£",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "GBP",
		"name_plural": "British pounds sterling"
	},
	"GEL": {
		"symbol": "GEL",
		"name": "Georgian Lari",
		"symbol_native": "GEL",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "GEL",
		"name_plural": "Georgian laris"
	},
	"GHS": {
		"symbol": "GH₵",
		"name": "Ghanaian Cedi",
		"symbol_native": "GH₵",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "GHS",
		"name_plural": "Ghanaian cedis"
	},
	"GNF": {
		"symbol": "FG",
		"name": "Guinean Franc",
		"symbol_native": "FG",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "GNF",
		"name_plural": "Guinean francs"
	},
	"GTQ": {
		"symbol": "GTQ",
		"name": "Guatemalan Quetzal",
		"symbol_native": "Q",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "GTQ",
		"name_plural": "Guatemalan quetzals"
	},
	"HKD": {
		"symbol": "HK$",
		"name": "Hong Kong Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "HKD",
		"name_plural": "Hong Kong dollars"
	},
	"HNL": {
		"symbol": "HNL",
		"name": "Honduran Lempira",
		"symbol_native": "L",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "HNL",
		"name_plural": "Honduran lempiras"
	},
	"HRK": {
		"symbol": "kn",
		"name": "Croatian Kuna",
		"symbol_native": "kn",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "HRK",
		"name_plural": "Croatian kunas"
	},
	"HUF": {
		"symbol": "Ft",
		"name": "Hungarian Forint",
		"symbol_native": "Ft",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "HUF",
		"name_plural": "Hungarian forints"
	},
	"IDR": {
		"symbol": "Rp",
		"name": "Indonesian Rupiah",
		"symbol_native": "Rp",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "IDR",
		"name_plural": "Indonesian rupiahs"
	},
	"ILS": {
		"symbol": "₪",
		"name": "Israeli New Sheqel",
		"symbol_native": "₪",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "ILS",
		"name_plural": "Israeli new sheqels"
	},
	"INR": {
		"symbol": "₹",
		"name": "Indian Rupee",
		"symbol_native": "Rs.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "INR",
		"name_plural": "Indian rupees"
	},
	"IQD": {
		"symbol": "IQD",
		"name": "Iraqi Dinar",
		"symbol_native": "د.ع.‏",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "IQD",
		"name_plural": "Iraqi dinars"
	},
	"IRR": {
		"symbol": "IRR",
		"name": "Iranian Rial",
		"symbol_native": "﷼",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "IRR",
		"name_plural": "Iranian rials"
	},
	"ISK": {
		"symbol": "Ikr",
		"name": "Icelandic Króna",
		"symbol_native": "kr",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "ISK",
		"name_plural": "Icelandic krónur"
	},
	"JMD": {
		"symbol": "J$",
		"name": "Jamaican Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "JMD",
		"name_plural": "Jamaican dollars"
	},
	"JOD": {
		"symbol": "JD",
		"name": "Jordanian Dinar",
		"symbol_native": "د.أ.‏",
		"decimal_digits": 3,
		"rounding": 0,
		"code": "JOD",
		"name_plural": "Jordanian dinars"
	},
	"JPY": {
		"symbol": "¥",
		"name": "Japanese Yen",
		"symbol_native": "￥",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "JPY",
		"name_plural": "Japanese yen"
	},
	"KES": {
		"symbol": "Ksh",
		"name": "Kenyan Shilling",
		"symbol_native": "Ksh",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "KES",
		"name_plural": "Kenyan shillings"
	},
	"KHR": {
		"symbol": "KHR",
		"name": "Cambodian Riel",
		"symbol_native": "៛",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "KHR",
		"name_plural": "Cambodian riels"
	},
	"KMF": {
		"symbol": "CF",
		"name": "Comorian Franc",
		"symbol_native": "FC",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "KMF",
		"name_plural": "Comorian francs"
	},
	"KRW": {
		"symbol": "₩",
		"name": "South Korean Won",
		"symbol_native": "₩",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "KRW",
		"name_plural": "South Korean won"
	},
	"KWD": {
		"symbol": "KD",
		"name": "Kuwaiti Dinar",
		"symbol_native": "د.ك.‏",
		"decimal_digits": 3,
		"rounding": 0,
		"code": "KWD",
		"name_plural": "Kuwaiti dinars"
	},
	"KZT": {
		"symbol": "KZT",
		"name": "Kazakhstani Tenge",
		"symbol_native": "тңг.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "KZT",
		"name_plural": "Kazakhstani tenges"
	},
	"LBP": {
		"symbol": "L.L.",
		"name": "Lebanese Pound",
		"symbol_native": "ل.ل.‏",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "LBP",
		"name_plural": "Lebanese pounds"
	},
	"LKR": {
		"symbol": "SLRs",
		"name": "Sri Lankan Rupee",
		"symbol_native": "SL Re",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "LKR",
		"name_plural": "Sri Lankan rupees"
	},
	"LTL": {
		"symbol": "Lt",
		"name": "Lithuanian Litas",
		"symbol_native": "Lt",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "LTL",
		"name_plural": "Lithuanian litai"
	},
	"LVL": {
		"symbol": "Ls",
		"name": "Latvian Lats",
		"symbol_native": "Ls",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "LVL",
		"name_plural": "Latvian lati"
	},
	"LYD": {
		"symbol": "LD",
		"name": "Libyan Dinar",
		"symbol_native": "د.ل.‏",
		"decimal_digits": 3,
		"rounding": 0,
		"code": "LYD",
		"name_plural": "Libyan dinars"
	},
	"MAD": {
		"symbol": "MAD",
		"name": "Moroccan Dirham",
		"symbol_native": "د.م.‏",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "MAD",
		"name_plural": "Moroccan dirhams"
	},
	"MDL": {
		"symbol": "MDL",
		"name": "Moldovan Leu",
		"symbol_native": "MDL",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "MDL",
		"name_plural": "Moldovan lei"
	},
	"MGA": {
		"symbol": "MGA",
		"name": "Malagasy Ariary",
		"symbol_native": "MGA",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "MGA",
		"name_plural": "Malagasy Ariaries"
	},
	"MKD": {
		"symbol": "MKD",
		"name": "Macedonian Denar",
		"symbol_native": "MKD",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "MKD",
		"name_plural": "Macedonian denari"
	},
	"MMK": {
		"symbol": "MMK",
		"name": "Myanma Kyat",
		"symbol_native": "K",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "MMK",
		"name_plural": "Myanma kyats"
	},
	"MOP": {
		"symbol": "MOP$",
		"name": "Macanese Pataca",
		"symbol_native": "MOP$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "MOP",
		"name_plural": "Macanese patacas"
	},
	"MUR": {
		"symbol": "MURs",
		"name": "Mauritian Rupee",
		"symbol_native": "MURs",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "MUR",
		"name_plural": "Mauritian rupees"
	},
	"MXN": {
		"symbol": "MX$",
		"name": "Mexican Peso",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "MXN",
		"name_plural": "Mexican pesos"
	},
	"MYR": {
		"symbol": "RM",
		"name": "Malaysian Ringgit",
		"symbol_native": "RM",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "MYR",
		"name_plural": "Malaysian ringgits"
	},
	"MZN": {
		"symbol": "MTn",
		"name": "Mozambican Metical",
		"symbol_native": "MTn",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "MZN",
		"name_plural": "Mozambican meticals"
	},
	"NAD": {
		"symbol": "N$",
		"name": "Namibian Dollar",
		"symbol_native": "N$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "NAD",
		"name_plural": "Namibian dollars"
	},
	"NGN": {
		"symbol": "₦",
		"name": "Nigerian Naira",
		"symbol_native": "₦",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "NGN",
		"name_plural": "Nigerian nairas"
	},
	"NIO": {
		"symbol": "C$",
		"name": "Nicaraguan Córdoba",
		"symbol_native": "C$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "NIO",
		"name_plural": "Nicaraguan córdobas"
	},
	"NOK": {
		"symbol": "Nkr",
		"name": "Norwegian Krone",
		"symbol_native": "kr",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "NOK",
		"name_plural": "Norwegian kroner"
	},
	"NPR": {
		"symbol": "NPRs",
		"name": "Nepalese Rupee",
		"symbol_native": "नेरू",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "NPR",
		"name_plural": "Nepalese rupees"
	},
	"NZD": {
		"symbol": "NZ$",
		"name": "New Zealand Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "NZD",
		"name_plural": "New Zealand dollars"
	},
	"OMR": {
		"symbol": "OMR",
		"name": "Omani Rial",
		"symbol_native": "ر.ع.‏",
		"decimal_digits": 3,
		"rounding": 0,
		"code": "OMR",
		"name_plural": "Omani rials"
	},
	"PAB": {
		"symbol": "B/.",
		"name": "Panamanian Balboa",
		"symbol_native": "B/.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "PAB",
		"name_plural": "Panamanian balboas"
	},
	"PEN": {
		"symbol": "S/.",
		"name": "Peruvian Nuevo Sol",
		"symbol_native": "S/.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "PEN",
		"name_plural": "Peruvian nuevos soles"
	},
	"PHP": {
		"symbol": "₱",
		"name": "Philippine Peso",
		"symbol_native": "₱",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "PHP",
		"name_plural": "Philippine pesos"
	},
	"PKR": {
		"symbol": "PKRs",
		"name": "Pakistani Rupee",
		"symbol_native": "₨",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "PKR",
		"name_plural": "Pakistani rupees"
	},
	"PLN": {
		"symbol": "zł",
		"name": "Polish Zloty",
		"symbol_native": "zł",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "PLN",
		"name_plural": "Polish zlotys"
	},
	"PYG": {
		"symbol": "₲",
		"name": "Paraguayan Guarani",
		"symbol_native": "₲",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "PYG",
		"name_plural": "Paraguayan guaranis"
	},
	"QAR": {
		"symbol": "QR",
		"name": "Qatari Rial",
		"symbol_native": "ر.ق.‏",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "QAR",
		"name_plural": "Qatari rials"
	},
	"RON": {
		"symbol": "RON",
		"name": "Romanian Leu",
		"symbol_native": "RON",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "RON",
		"name_plural": "Romanian lei"
	},
	"RSD": {
		"symbol": "din.",
		"name": "Serbian Dinar",
		"symbol_native": "дин.",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "RSD",
		"name_plural": "Serbian dinars"
	},
	"RUB": {
		"symbol": "RUB",
		"name": "Russian Ruble",
		"symbol_native": "₽.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "RUB",
		"name_plural": "Russian rubles"
	},
	"RWF": {
		"symbol": "RWF",
		"name": "Rwandan Franc",
		"symbol_native": "FR",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "RWF",
		"name_plural": "Rwandan francs"
	},
	"SAR": {
		"symbol": "SR",
		"name": "Saudi Riyal",
		"symbol_native": "ر.س.‏",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "SAR",
		"name_plural": "Saudi riyals"
	},
	"SDG": {
		"symbol": "SDG",
		"name": "Sudanese Pound",
		"symbol_native": "SDG",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "SDG",
		"name_plural": "Sudanese pounds"
	},
	"SEK": {
		"symbol": "Skr",
		"name": "Swedish Krona",
		"symbol_native": "kr",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "SEK",
		"name_plural": "Swedish kronor"
	},
	"SGD": {
		"symbol": "S$",
		"name": "Singapore Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "SGD",
		"name_plural": "Singapore dollars"
	},
	"SOS": {
		"symbol": "Ssh",
		"name": "Somali Shilling",
		"symbol_native": "Ssh",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "SOS",
		"name_plural": "Somali shillings"
	},
	"SYP": {
		"symbol": "SY£",
		"name": "Syrian Pound",
		"symbol_native": "ل.س.‏",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "SYP",
		"name_plural": "Syrian pounds"
	},
	"THB": {
		"symbol": "฿",
		"name": "Thai Baht",
		"symbol_native": "฿",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "THB",
		"name_plural": "Thai baht"
	},
	"TND": {
		"symbol": "DT",
		"name": "Tunisian Dinar",
		"symbol_native": "د.ت.‏",
		"decimal_digits": 3,
		"rounding": 0,
		"code": "TND",
		"name_plural": "Tunisian dinars"
	},
	"TOP": {
		"symbol": "T$",
		"name": "Tongan Paʻanga",
		"symbol_native": "T$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "TOP",
		"name_plural": "Tongan paʻanga"
	},
	"TRY": {
		"symbol": "TL",
		"name": "Turkish Lira",
		"symbol_native": "TL",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "TRY",
		"name_plural": "Turkish Lira"
	},
	"TTD": {
		"symbol": "TT$",
		"name": "Trinidad and Tobago Dollar",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "TTD",
		"name_plural": "Trinidad and Tobago dollars"
	},
	"TWD": {
		"symbol": "NT$",
		"name": "New Taiwan Dollar",
		"symbol_native": "NT$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "TWD",
		"name_plural": "New Taiwan dollars"
	},
	"TZS": {
		"symbol": "TSh",
		"name": "Tanzanian Shilling",
		"symbol_native": "TSh",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "TZS",
		"name_plural": "Tanzanian shillings"
	},
	"UAH": {
		"symbol": "₴",
		"name": "Ukrainian Hryvnia",
		"symbol_native": "₴",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "UAH",
		"name_plural": "Ukrainian hryvnias"
	},
	"UGX": {
		"symbol": "USh",
		"name": "Ugandan Shilling",
		"symbol_native": "USh",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "UGX",
		"name_plural": "Ugandan shillings"
	},
	"UYU": {
		"symbol": "$U",
		"name": "Uruguayan Peso",
		"symbol_native": "$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "UYU",
		"name_plural": "Uruguayan pesos"
	},
	"UZS": {
		"symbol": "UZS",
		"name": "Uzbekistan Som",
		"symbol_native": "UZS",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "UZS",
		"name_plural": "Uzbekistan som"
	},
	"VEF": {
		"symbol": "Bs.F.",
		"name": "Venezuelan Bolívar",
		"symbol_native": "Bs.F.",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "VEF",
		"name_plural": "Venezuelan bolívars"
	},
	"VND": {
		"symbol": "₫",
		"name": "Vietnamese Dong",
		"symbol_native": "₫",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "VND",
		"name_plural": "Vietnamese dong"
	},
	"XAF": {
		"symbol": "FCFA",
		"name": "CFA Franc BEAC",
		"symbol_native": "FCFA",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "XAF",
		"name_plural": "CFA francs BEAC"
	},
	"XCD": {
		"symbol": "EC$",
		"name": "Eastern Caribbean dollar",
		"symbol_native": "EC$",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "XCD",
		"name_plural": "Eastern Caribbean dollars"
	},
	"XOF": {
		"symbol": "CFA",
		"name": "CFA Franc BCEAO",
		"symbol_native": "CFA",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "XOF",
		"name_plural": "CFA francs BCEAO"
	},
	"YER": {
		"symbol": "YR",
		"name": "Yemeni Rial",
		"symbol_native": "ر.ي.‏",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "YER",
		"name_plural": "Yemeni rials"
	},
	"ZAR": {
		"symbol": "R",
		"name": "South African Rand",
		"symbol_native": "R",
		"decimal_digits": 2,
		"rounding": 0,
		"code": "ZAR",
		"name_plural": "South African rand"
	},
	"ZMK": {
		"symbol": "ZK",
		"name": "Zambian Kwacha",
		"symbol_native": "ZK",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "ZMK",
		"name_plural": "Zambian kwachas"
	},
	"ZWL": {
		"symbol": "ZWL$",
		"name": "Zimbabwean Dollar",
		"symbol_native": "ZWL$",
		"decimal_digits": 0,
		"rounding": 0,
		"code": "ZWL",
		"name_plural": "Zimbabwean Dollar"
	}
}
export const dataTypeC = ["Text", "Document", "Radio Button", "Picklist", "Long Text", "Number", "Output Message", "Phone", "Email", "Date", "Currency", "Multiselect Picklist", "Signature", "Checkbox", "Date(Month-Year)", "Video", "Date(Year)", "Date(Date-Month-Year)", "Signature With Timestamp"].sort();

// export const dataTypeScoreCard = ["Text", "Radio Button", "Picklist", "Long Text", "Number", "Phone", "Email", "Currency", "Multiselect Picklist", "Checkbox", "Output Message"].sort();

export const hidePreviewButton = ["Under Review", "Closed", "Accepting Applications", "Review Board"]

export const dataTypeScoreCard = ["Text", "Number"].sort();

// export const dataTypeRecommendation = ["Text", "Document", "Radio Button", "Long Text", "Number", "Output Message", "Phone", "Email", "Date", "Currency", "Multiselect Picklist", "Signature", "Checkbox", "Date(Month-Year)", "Date(Year)", "Date(Date-Month-Year)", "Dropdown", "Percent"].sort();

export const dataTypeRecommendation = [{ "label": "Text", "value": "Text" }, { "label": "Document", "value": "Document" }, { "label": "Radio Button", "value": "Radio Button" }, { "label": "Long Text", "value": "Long Text" }, { "label": "Number", "value": "Number" }, { "label": "Output Message", "value": "Output Message" }, { "label": "Phone", "value": "Phone" }, { "label": "Email", "value": "Email" }, { "label": "Date", "value": "Date" }, { "label": "Currency", "value": "Currency" }, { "label": "Multiselect Picklist", "value": "Multiselect Picklist" }, { "label": "Signature", "value": "Signature" }, { "label": "Checkbox", "value": "Checkbox" }, { "label": "Date(Month-Year)", "value": "Date(Month-Year)" }, { "label": "Date(Year)", "value": "Date(Year)" }, { "label": "Date(Date-Month-Year)", "value": "Date(Date-Month-Year)" }, { "label": "Dropdown", "value": "Dropdown" }, { "label": "Percent", "value": "Percent" }]


export const FRONTENDTOSALESFORCESYNC_OPERATOR =  [
													{ label: 'Contains', value: 'contains' },
													{ label: 'Not Contains', value: 'not_contains' },
													{ label: 'Equals', value: 'is_equal_to' },
													{ label: 'Not Equals', value: 'is_not_equal_to' },
												]
export const reportTypeOptionsDonor = [
  { label: "Application Information Report (XLS)", value: "Application Information Report (XLS)" },
  { label: "Application Information Report (PDF)", value: "Application Information Report (PDF)" },
  { label: "Contributor Status Report", value: "Contributor Status Report" },
  { label: "Disbursement Report", value: "Disbursement Report" },
  { label: "Donation Report", value: "Donation Report" },
  { label: "Qualifying Report", value: "Qualifying Report" },
  { label: "Score Report", value: "Score Report" },
];

export const dataTypeDropdown = ["Radio Button", "Picklist", "Multiselect Picklist", "Checkbox", "Dropdown"]
export const FRONTEND_TO_SALESFORCE_SYNC_OBJECT = {
	HEROKU_CONNECT_ERRORS: 'herokuConnectErrors',
	FRONTEND_TO_SALESFORCE_SYNC: 'frontendToSalesforceSync',
	FRONTEND_APPLICATION_SYNC_TO_ELEMENTS: 'frontendApplicationSyncToElements',
	FRONTEND_CONTACT_TO_ELEMENTS: 'frontendContactToElements',
	ROWS_IN_FRONTEND: 'rowsInFrontend'
}

export const checkQuestionTypeAwardBuilder = ['Picklist', 'Multiselect Picklist', 'Radio Button', "Checkbox", "Dropdown"]
// TODO: Determine data types docs
export const allDocType = ["Document", "Video", "Audio"]
export const dataTypeDoc = ["Document", "Video"]
export const docDataType = ["Document"]
export const videoDataType = ["Video"]
export const dateDataType = ["Date(Date-Month-Year)", "Date(Month-Date-Year)", "Date", "Date(Month-Year)", "Date(Year)"]

// TODO: Determine data types join
export const dataTypeJoin = ["Multiselect Picklist", "Checkbox"]

// TODO: Determine data types join
// export const dataTypeReadOnly = ["Application__c.First_Name__c", "Application__c.Last_Name__c", "Application__c.Email_Address__c", "Formula", "Roll Up Iterations", "Application__c.School_Institution_Street__c", "Application__c.School_Institution_City__c", "Contact.Application__c.School_Institution_State__c", "Application__c.School_Institution_Zip_Postal_Code__c", "Text"]
export const dataTypeReadOnly = ["Application__c.First_Name__c", "Application__c.Last_Name__c", "Application__c.Email_Address__c", "Formula", "Roll Up Iterations"]
export const dataTypeReadOnlyWithoutLogin = ["Formula", "Roll Up Iterations"]
export const dataTypeForSignup = ["Application__c.First_Name__c", "Application__c.Last_Name__c", "Application__c.Email_Address__c"]

export const enabledApplyButton = ["Accepting Applications", "Prototype"]
export const enabledPreviewApplyButton = ["Accepting Applications", "Prototype", "Draft"]


export const imageType = ["png", "jpg", "jpeg", "gif", "bmp"]
export const unsupportiveImageType = ["heic"]
export const docType = ["doc", "pdf", "txt", "docx", "xls", "xlsx", "ppt", "pptx", "odt", "ods", "csv", "rtf", "html","htm","xlsm","tif", "tiff"]
export const videoType = ["3gp", "mp4", "m2v", "m4v", "f4v", "f4a", "mkv", "m4b", "m4r", "f4b", "mov", "3g2", "ogg", "oga", "ogv", "ogx", "wmv", "wma", "webm", "avi", "mpeg", "mpeg2", "mpeg4", "flv"]
export const audioType = ["mp3", "wav", "aif", "mid", "aac", "flac", "aiff", "ac3", "au", "dsd", "m4a", "alac", "ape", "caf", "amr", "opus", "wv", "s3m", "mod"]
export const supportedFileType = ["mkv", "m4a", "m4v", "wav", "mpeg", "bmp", "tif", "heif", "webm", "heic", "doc", "docx", "xls", "xlsx", "csv", "pdf", "rtf", "mp3", "wma", "flv", "avi", "jpg", "jpeg", "png", "gif", "mov", "mp4"]

// TODO: Determine country list
export const countryList = ["All Countries", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Indian Ocean Territory", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo Republic", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "DR Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Federated States of Micronesia", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Moldova", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Principality of Monaco", "Puerto Rico", "Qatar", "Romania", "Russia", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "St Kitts and Nevis", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syria", "São Tomé and Príncipe", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "No Citizenship Requirement"]
// TODO: Determine US state list
export const stateList = ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "U.S. Virgin Islands", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"]

// TODO: Determine Disbursement state list
export const stateListForDisbursement=['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC','GU'] 

// TODO: Determine Disbursement status list
export const statusList=['Approved','Scheduled','Pending','Submitted','Completed','Cancelled','Sent','Paid','Rejected']

// TODO: Determine Disbursement payment type list
export const paymentTypeList=['CHECK','E-Check','AMEX','VISA','ACH','Debit Card','Discover Card','EFT','Gift Card','Loan','Mastercard','PayPal','Venmo','Wire Transfer','Computer Check','Credit Card','Fund Balance','Fund Withdrawal']

// TODO: Determine Disbursement academi year list
export const academiYearList=['2020/2021','2021/2022','2022/2023','2023/2024','2024/2025','2025/2026','2026/2027','2027/2028','2028/2029','2029/2030']

// TODO: Determine autoFillAddressFields
export const autoFillAddressFields = {
	'Country': 'mailing_country__c',
	'City': 'city__c',
	'State': 'mailing_state_province__c',
	'Zip': 'mailing_zip_postal_code__c'
}

export const scholarshipBuilderValidFields = ["scholarshipName", "urlBlank"]
export const scoreCardBuilderValidFields = ["scoreCardName", "scoreCardInstructions", "scoreCardStartDate", "scoreCardEndDate"]

export const relationShip = ["Mother", "Father", "Aunt", "Brother", "Grandfather", "Grandmother", "Legal Guardian", "Sister", "Uncle", "Conservator", "Step-Father", "Step-Mother"]
export const notEditable = ["Review Board", "Under Review", "Closed"]

export const iterationModalCloseMsg = "Any progress for your entry will not be saved until you hit “Submit”."
export const documentTypeArray=['Document', 'Text']
export const validateSelectTypeFields = ["Picklist", "Multiselect Picklist", "Radio Button", "Answer Dependent Picklist"]


export const MAIN_CONFIG = {
	ELEMENTS_URLS:{
		REVIEWER:{
			DASHBOARD: '/reviewer-portal/programs',
		},
		ADMIN:{
			SUPER_ADMIN: '/admin/dashboard'
		},

		CONTRIBUTOR: {
			DASHBOARD: '/contributor'
		},

		DONOR:{
			SCHOLARSHIP_BUILDER: (scholarshipId) => `/admin/program/${scholarshipId}/forms`,
			REVIEW_BOARD: (scholarshipId) => `/admin/review-board/${scholarshipId}`,
			CONNECT: (accountId) => `/admin/${accountId}/connect`,
			ALL_APPLICATIONS: (scholarshipId) => `/admin/program/${scholarshipId}/applications`,
			CREATE_NEW_SCHOLARSHIP:  `/admin/program/Create`,
			REPORT_DASHBOARD : (accountId) => `/admin/reporting/${accountId}/dashboard`,
			REPORT_List : (accountId) => `/admin/reporting/${accountId}/reports`,
			CONTACT : (accountId) => `/admin/${accountId}/contacts`,
			VIEW_APPLICATION : (scholarshipId, applicationId) => `/admin/program/${scholarshipId}/application/${applicationId}/client-overview`
		},

		APPLICANT:{
			SCHOLARSHIP: (scholarshipId) => `/program/${scholarshipId}`,
			APPLICATION: (scholarshipId, applicationId) => `/program/${scholarshipId}/applicant/application/${applicationId}`
		}
	},

	ACH_INFO_FILTERS: {
		STATUS: [
			{ label: 'Approved', value: 'Approved' },
			{ label: 'Ready for finance check (ACH)', value: 'Ready for finance check (ACH)' },
			{ label: 'Ready for finance check (International)', value: 'Ready for finance check (International)' },
			{ label: 'Ready for payment', value: 'Ready for payment' },
			{ label: 'Paid', value: 'Paid' }
		],

		FUNDS_MANAGED_BY: [
			{ label: 'Kaleidoscope', value: 'Kaleidoscope' }
		],

		PAYMENT_TYPE: [
			{ label: 'ACH', value: 'ACH' },
			{ label: 'Wire Transfer', value: 'Wire Transfer' }
		],
	},
	URLS: {
		BASE_URL: 'http://localhost:3000',
		//BASE_API_URL: 'https://api-dev.mykaleidoscope.com',
		BASE_API_URL: process.env.NEXT_PUBLIC_BASE_API_URL,
		// MYKALEIDOSCOPE_BASE_URL: 'https://app-dev.mykaleidoscope.com/',
		SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL,
		BASE: '/',
		LOGIN: '/login',
		SIGNUP: '/signup',
		SPONSORSIGNUP: '/sponsor-signup',
		PARENTALCONSENT: '/consent',
		SUPER_ADMIN: '/super-admin',
		SUPER_ADMIN_LOGIN: '/admin-login',
		ADMIN: "/admin",
		CALLBACK: "/callback",
		SALESFORCE_CALLBACKL: "salesforce/callback",
		ACCOUNT_SWITCH: '/account/switch',
		ROLE_SWITCH: '/account/role',
		LOGOUT: '/account/logout',
		PROFILE: '/profile',
		ACCOUNT_PREFERENCES: '/client/account',
		DONOR: {
			ACCOUNT: '/account',
			ADMIN: '/client/admin',
			DISBURSEMENTS: '/client/disbursements',
			COMMUNICATIONS: '/client/connect', 
			REPORTS: '/client/reports',
			HOME: '/client',
			SCHOLARSHIPS: '/client/scholarships',
			SINGLE_SCHOLARSHIP: (scholarshipId) => `/client/scholarships/${scholarshipId}`,
			PEOPLE: '/client/people',
			APPLICANTS: '/client/applications',
			NEW_SCHOLARSHIP: '/client/scholarships/new',
			EDIT_SCHOLARSHIP: (scholarshipId) => `/client/scholarships/${scholarshipId}/edit`,
			PREVIEW_SCHOLARSHIP: (scholarshipId) => `/client/scholarships/${scholarshipId}/preview`,
			SCHOLARSHIP_REVIEWERS: (scholarshipId) => `/client/scholarships/${scholarshipId}/reviewers`,
			// SCHOLARSHIP_REVIEWERS_ELEMENTS: (scholarshipId) => `/admin/review-board/${scholarshipId}`,
			MY_TASK: '/client/mytask',
			APPLICATION_SCCORE: (scholarshipId, applicationId) => `/client/scholarships/${scholarshipId}/applications/${applicationId}`,
			APPLICATION_UPDATE: (scholarshipId, applicationId) => `/client/scholarships/${scholarshipId}/applications/${applicationId}/update`,
			DONATIONS:'/client/donations'
		},
		REVIEWER: {
			DASHBOARD: '/reviewer',
			SINGLE_SCHOLARSHIP: (scholarshipId) => `/reviewer/scholarships/${scholarshipId}`,
			SINGLE_APPLICATION: (scholarshipId, applicationId) => `/reviewer/scholarships/${scholarshipId}/applications/${applicationId}`,
		},
		APPLICANT: {
			EXPLORE: '/applicant/',
			TASKS : '/applicant/tasks',
			SAVED : '/applicant/saved',
			APPLICATIONS: '/applicant/applications',
			PROFILE:'/applicant/profile',
			DONOR:'/applicant/donors',
			DISBURSEMENTS: '/applicant/disbursements',
			RESOURCES: '/applicant/resources',
			GRADEBOOK: '/applicant/gradebook'
		},
		APPLY: (scholarshipHerokuId, stepId) => `/apply/${scholarshipHerokuId}/${stepId}`,
		SINGLE_APPLICATION: (scholarshipId, applicationId) => `/scholarships/${scholarshipId}/applications/${applicationId}`,
		STAFF_APPLICATION: (applicationId) => `/application/${applicationId}`,
	},
	PAGE_TYPES: {
		LOGIN: 'LOGIN',
		SIGNUP: 'SIGNUP',
		SPONSORSIGNUP: 'SPONSORSIGNUP',
		PARENTALCONSENT: 'PARENTALCONSENT',
		SUPER_ADMIN: 'SUPER_ADMIN',
		RESET_PASSWORD: 'RESET_PASSWORD',
		SUPER_ADMIN_LOGIN: 'SUPER_ADMIN_LOGIN',
		SALESFORCE_CALLBACKL: "SALESFORCE_CALLBACKL",
		SSO_AUTHENTICATION: 'SSO_AUTHENTICATION',
		CALLBACK: "CALLBACK",
		ACCOUNT_SWITCH: 'ACCOUNT_SWITCH',
		ROLE_SWITCH: 'ROLE_SWITCH',
		LOGOUT_CONFIRM: 'LOGOUT_CONFIRM',
		DONOR: {
			ACCOUNT: 'ACCOUNT',
			HOME: 'HOME',
			ADMIN: 'ADMIN',
			SCHOLARSHIPS: 'SCHOLARSHIPS',
			APPLICATIONS: 'APPLICATIONS',
			APPLICATION_DETAILS: 'APPLICATION_DETAILS',
			PEOPLE: 'PEOPLE',
			APPLICANTS: 'APPLICANTS',
			DISBURSEMENTS: 'DISBURSEMENTS',
			REPORTS: 'REPORTS',
			NEW_SCHOLARSHIP: 'NEW_SCHOLARSHIP',
			EDIT_SCHOLARSHIP: 'EDIT_SCHOLARSHIP',
			PREVIEW_SCHOLARSHIP: 'PREVIEW_SCHOLARSHIP',
			MY_TASK: 'MY_TASK',
			APPLICATION_UPDATE: 'APPLICATION_UPDATE',
			REPORTS: 'REPORTS',
			SCHOLARSHIP_REVIEWERS: 'SCHOLARSHIP_REVIEWERS',
			COMMUNICATIONS: 'COMMUNICATIONS',
			DONATIONS:'DONATIONS',
			RECOMMENDATION_QUESTION_UPDATE: 'RECOMMENDATION_QUESTION_UPDATE',
		},
		REVIEWER: {
			APPLICATION_DETAILS: 'APPLICATION_DETAILS',
			IFRAME_APPLICATION_DETAILS: 'IFRAME_APPLICATION_DETAILS',
		},
		RECOMMENDER: {
			RECOMMENDATION: 'RECOMMENDATION_FORM'
		},
		APPLICANT: {
			SCHOLARSHIPS: 'SCHOLARSHIPS',
			APPLY: 'APPLY',
			RESUME: 'RESUME',
			TASKS : 'TASKS',
			SAVED : 'SAVED',
			APPLICATIONS: 'MYAPPLICATIONS',
			PROFILE:'PROFILE',
			DISBURSEMENTS: 'DISBURSEMENTS',
			RESOURCES: 'RESOURCES',
			GRADEBOOK: 'GRADEBOOK',
			DONORS: 'DONORS'
		},
		APPLICATION: {
			APPLICATION: 'APPLICATION',
		}
	},
	USER_CONTEXT: {
		LOGGED_OUT: 'LOGGED_OUT',
		DONOR: 'DONOR',
		SUPERDONOR: 'SUPERDONOR',
		RECOMMENDER: 'RECOMMENDER',
		REVIEWER: 'REVIEWER',
		APPLICANT: 'APPLICANT',
		NGB: 'NGB',
		VERIFIER: 'VERIFIER',
		SCHOOLCOUNSELLOR: 'SCHOOLCOUNSELLOR',
		ENDORSEDUSER: 'ENDORSEDUSER',
		TEAMMEMBER: 'TEAMMEMBER',
		THIRDPARTYCONTRIBUTOR: 'THIRDPARTYCONTRIBUTOR',
		UNIVERSITYSTAFF: 'UNIVERSITYSTAFF',
		HSSTAFF: 'HSSTAFF',
		COLLEGESTAFF: 'COLLEGESTAFF',
		DETROITSF: 'DETROITSF',
		ADMIN: 'ADMIN'
	},
	USER_ROLE_CONTEXT: [
		{ label: 'Super Donor', role: 'Super Donor', context: 'SUPERDONOR', order: 1, link: '/client' },
		{ label: 'Client', role: 'Client', context: 'DONOR', order: 2, link: '/client' },
		{ label: 'Review Board Member', role: 'Review Board Member', context: 'REVIEWER', order: 3, link: '/reviewer' },
		{ label: 'Recommender User', role: 'Recommender User', context: 'RECOMMENDER', order: 4, link: '/contributor' },
		{ label: 'School Counselor', role: 'School Counsellor', context: 'SCHOOLCOUNSELLOR', order: 5, link: '/contributor' },
		{ label: 'Endorser User', role: 'Endorser User', context: 'ENDORSEDUSER', order: 6, link: '/contributor' },
		{ label: 'NGB', role: 'NGB', context: 'NGB', order: 7, link: '/contributor' },
		{ label: 'Team Member', role: 'Team Member', context: 'TEAMMEMBER', order: 8, link: '/applicant' },
		{ label: 'Third Party Contributor', role: 'Third Party Contributor', context: 'THIRDPARTYCONTRIBUTOR', order: 9, link: '/contributor' },
		{ label: 'Applicant', role: 'Applicant', context: 'APPLICANT', order: 10, link: '/applicant' },
		{ label: 'University Staff', role: 'University Staff', context: 'UNIVERSITYSTAFF', order: 11, link: '/' },
		{ label: 'HS Staff', role: 'HS Staff', context: 'HSSTAFF', order: 12, link: '/' },
		{ label: 'College Staff', role: 'College Staff', context: 'COLLEGESTAFF', order: 13, link: '/' },
		{ label: 'Detroit SF', role: 'Detroit SF', context: 'DETROITSF', order: 14, link: '/' },
		{ label: 'Admin', role: 'Admin', context: 'ADMIN', order: 0, link: '/admin' },
		{ label: 'Verifier', role: 'Verifier', context: 'VERIFIER', order: 15, link: '/contributor' },
	],
	USER_ROLE_LIST: [
		{ label: 'NGB', value: 'NGB' },
		{ label: 'Client', value: 'Client' },
		{ label: 'Applicant', value: 'Applicant' },
		{ label: 'Verifier', value: 'Verifier' },
		{ label: 'Endorser User', value: 'Endorser User' },
		{ label: 'School Counselor', value: 'School Counsellor' },
		{ label: 'Recommender User', value: 'Recommender User' },
		{ label: 'Review Board Member', value: 'Review Board Member' },
		{ label: 'Third Party Contributor', value: 'Third Party Contributor' },
	],
	COLORS: {
		fillBeige: '#e2e1cd',
		fillBlack: '#1a282c',
		fillPink: '#ffa3d1',
		fillBrown: '#db7b1c',
		fillLightBlue: '#98dde7',
		fillBlue: '#1C21DF',
		fillWhite: '#ffffff',
		fillLightGrey: '#f6f6f6',
		fillRed: '#FF542D',
		fillGreen: '#1E5558',
		fillGrey: '#979797',
		fillYellow: '#ffcd00',
		fillDarkGrey: '#737373',
		fillSoftBlack: '#364e55',
		faintGrey: '#f0f2f2',
		fillGrey2: '#696969',
		fillDarkBlue: '#008291',
		fillHoverGray: '#ebebeb',
		fillDarkBlackIcon: '#555555',
		fillfacebook: '#4267B2',
		filltwitter: '#1DA1F2',
		filllinkedin: '#0077b5',
		fillBeigePagesModalsPopUps: '#F7F7F3',
		fillBlueColor: "#1C21DF",
		fillGraySuccess: "#434445",
		fillLightOrange: "#F7CAC8"

	},
	SEARCH: {
		DELAY: 500
	},
	NAVLABElS:['Applications', 'Explore', 'Gradebook', 'Donors', 'Disbursements', 'Resources'],
	SCHOLARSHIPS: {
		MAX_RECIPIENTS: 5,
		DESCRIPTION_CHAR_LIMIT: 2500,
		GRADE_LEVEL_OPTIONS: [
			{ label: 'Middle School', value: 'Middle School' },
			{ label: 'H.S. Freshman', value: 'H.S. Freshman' },
			{ label: 'H.S. Sophomore', value: 'H.S. Sophomore' },
			{ label: 'H.S. Junior', value: 'H.S. Junior' },
			{ label: 'H.S. Senior', value: 'H.S. Senior' },
			{ label: 'Undergrad', value: 'Undergrad' },
			{ label: 'Graduate', value: 'Graduate' }
		],
		USA_TIME_ZONE_OPTIONS: [
			{ label: 'Select Timezone', value: '' },
			{ label: 'America/NewYork', value: 'America/New_York' },
			{ label: 'America/Chicago', value: 'America/Chicago' },
			{ label: 'America/Denver', value: 'America/Denver' },
			{ label: 'America/Los Angeles', value: 'America/Los_Angeles' },
			{ label: 'America/Phoenix', value: 'America/Phoenix' },
			{ label: 'America/Anchorage', value: 'America/Anchorage' },
			{ label: 'Pacific/Honolulu', value: 'Pacific/Honolulu' }
		],
		APP_LIMIT_OPTIONS: [
			{ label: 'No Limit', value: '0' },
			{ label: '100', value: 100 },
			{ label: '500', value: 500 },
			{ label: '1,000', value: 1000 },
			{ label: '2,000', value: 2000 }
		],
		GPA_OPTIONS: [
			{ label: 'Select GPA', value: '' },
			{ label: 'Above 1.0', value: '1' },
			{ label: 'Above 1.5', value: '1.5' },
			{ label: 'Above 2.0', value: '2' },
			{ label: 'Above 2.5', value: '2.5' },
			{ label: 'Above 3.0', value: '3' },
			{ label: 'Above 3.5', value: '3.5' },
			{ label: 'Above 4.0', value: '4' },
		],
		CATEGORY_OPTIONS: [
			{ label: 'Leadership', value: 'Leadership' },
			{ label: 'Entrepreneurship', value: 'Entrepreneurship' },
			{ label: 'Business', value: 'Business' },
			{ label: 'Arts', value: 'Arts' },
			{ label: 'Environment', value: 'Environment' },
			{ label: 'Sports', value: 'Sports' },
			{ label: 'Animal Science', value: 'Animal Science' },
			{ label: 'Agriculture', value: 'Agriculture' },
			{ label: 'Forestry', value: 'Forestry' },
			{ label: 'Retail', value: 'Retail' },
			{ label: 'Political Science', value: 'Political Science' },
			{ label: 'Film', value: 'Film' },
			{ label: 'STEM', value: 'STEM' },
			{ label: 'Financial Need Based vs Non Financial Need Based', value: 'Financial Need Based vs Non Financial Need Based' },
			{ label: 'Education', value: 'Education' },
			{ label: 'Military', value: 'Military' },
			{ label: 'State Specific Scholarships', value: 'State Specific Scholarships' },
			{ label: 'Minority', value: 'Minority' },
			{ label: 'Religious', value: 'Religious' },
			{ label: 'Local Scholarship', value: 'Local Scholarship' },
			{ label: 'National Scholarship', value: 'National Scholarship' },
			{ label: 'Graduate Degree', value: 'Graduate Degree' },
			{ label: 'Undergraduate Degree', value: 'Undergraduate Degree' },
			{ label: 'Graduate', value: 'Graduate' },
			{ label: 'Diversity', value: 'Diversity' },
			{ label: 'Merit Based vs Non Merit Based', value: 'Merit Based vs Non Merit Based' },
			{ label: 'Engineering', value: 'Engineering' },
			{ label: 'Natural Science', value: 'Natural Science' },
			{ label: 'Nursing', value: 'Nursing' },
			{ label: 'Liberal Arts', value: 'Liberal Arts' },
			{ label: 'Law', value: 'Law' },
			{ label: 'Merit Based vs Non Merit Based', value: 'Merit Based vs Non Merit Based' },
			{ label: 'Academic Achievement', value: 'Academic Achievement' },
			{ label: 'Career Emphasis', value: 'Career Emphasis' },
			{ label: 'Community Involvement', value: 'Community Involvement' },
			{ label: 'Personal Courage', value: 'Personal Courage' },
			{ label: 'Good Citizenship/Character', value: 'Good Citizenship/Character' },
			{ label: 'Writing/Journalism', value: 'Writing/Journalism' },
			{ label: 'Community College, Trade or Vocational School', value: 'Community College, Trade or Vocational School' },
		],
		CITIZENSHIP_OPTIONS: [
			{ label: 'Select Citizenship', value: '' },
			{ label: 'U.S. Citizens Only', value: 'U.S. Citizens Only' },
			{ label: 'Non-US Citizen', value: 'Non-US Citizen' },
			{ label: 'Any Citizenship', value: 'Any Citizenship' },
		],
		SCHOLARSHIP_LESS_TILE: 12,
		SCHOLARSHIP_MORE_TILE: 100
	},
	DONOR: {
		PRIORITY_OPTIONS: [
			{ label: 'High', value: 'High' },
			{ label: 'Medium', value: 'Medium' },
			{ label: 'Normal', value: 'Normal' }
		],
		BUILDER_CONTEXT: ['scholarship', 'application', 'scorecard', 'recommendation'],
		ADMIN: {
			BUILDER_CONTEXT_MAPPING: {
				'Scholarship Templates': 'scholarship',
				'Application Templates': 'application',
				'Scorecard Templates': 'scorecard',
				'Recommender Templates': 'recommendation'
			},
			TABLE_HEADERS: {
				SCHOLARSHIP: [
					{ field_api_name__c: 'name', column_name__c: 'Scholarship', enable_sort__c: true },
					{ field_api_name__c: 'open_date__c', column_name__c: 'Open Date', enable_sort__c: true },
					{ field_api_name__c: 'deadline_date_time__c', column_name__c: 'Due Date', enable_sort__c: true },
					{ field_api_name__c: 'status__c', column_name__c: 'Status', enable_sort__c: true }
				],
				APPLICATION: [
					{ field_api_name__c: 'name', column_name__c: 'Application', enable_sort__c: true },
					{ field_api_name__c: 'steps_count', column_name__c: '# Sections', enable_sort__c: true },
					{ field_api_name__c: 'configs_count', column_name__c: 'Length', enable_sort__c: true }
				],
				SCORECARD: [
					{ field_api_name__c: 'name', column_name__c: 'Scorecard', enable_sort__c: true },
					{ field_api_name__c: 'asc_questions_count', column_name__c: '# Questions', enable_sort__c: true },
					{ field_api_name__c: 'asc_questions_weight', column_name__c: 'Total Possible Marks', enable_sort__c: true }
				],
				RECOMMENDER: [
					{ field_api_name__c: 'name', column_name__c: 'Recommendation', enable_sort__c: true },
					{ field_api_name__c: 'rc_questions_count', column_name__c: '# Questions', enable_sort__c: true }
				],
				REPORTS: [
					{ field_api_name__c: 'file_name', column_name__c: 'File Name', enable_sort__c: true, tdCustomClass: 'donor_reports_name' },
					{ field_api_name__c: 'scholarship_name', column_name__c: 'Program', enable_sort__c: true },
					{ field_api_name__c: 'report_type', column_name__c: 'Report Type', enable_sort__c: true },
					{ field_api_name__c: 'export_type', column_name__c: 'Export Type', enable_sort__c: true },
					{ field_api_name__c: 'created_at', column_name__c: 'Created On', enable_sort__c: true },
					{ field_api_name__c: 'expired_at', column_name__c: 'Expires On', enable_sort__c: true }
				],
				DONATIONS:[
					{field_api_name__c: "name",column_name__c: "Fund Name",enable_sort__c: true,order__c: 1,field_data_type__c: "Text"},
					{field_api_name__c: "first_name__c",column_name__c: "Donor First Name",enable_sort__c: true,order__c: 2,field_data_type__c: "Text"},
				    {field_api_name__c: "last_name__c",column_name__c: "Donor Last Name",enable_sort__c: true,order__c: 3,field_data_type__c: "Text"},
					{field_api_name__c: "email_address__c",column_name__c: "Donor Email",enable_sort__c: true,order__c: 4,field_data_type__c: "Text"},
				    {field_api_name__c: "createddate",column_name__c: "Date Donated",enable_sort__c: true,order__c: 5,field_data_type__c: "Date"},
				    {field_api_name__c: "amount__c",column_name__c: "Amount Donated",enable_sort__c: true,order__c: 6,field_data_type__c: "Currency",primaryColor:"#1C21DF"}
				]
			},
			SIDEBAR_TABS: {
				SCHOLARSHIP: 'Scholarship Templates',
				APPLICATION: 'Application Templates',
				SCORECARD: 'Scorecard Templates',
				RECOMMENDER: 'Recommender Templates'
			}
		}
	},
	APPLICANT: {
		NO_ESSAY: [
			false,
		],
		CATEGORIES: [
			{ label: 'Diversity + Inclusion', value: 'Diversity + Inclusion' },
			{ label: 'Leadership', value: 'Leadership' },
			{ label: 'Entrepreneurship', value: 'Entrepreneurship' },
			{ label: 'Business', value: 'Business' },
			{ label: 'Arts', value: 'Arts' },
			{ label: 'Environment', value: 'Environment' },
			{ label: 'Sports', value: 'Sports' },
			{ label: 'Animal Science', value: 'Animal Science' },
			{ label: 'Agriculture', value: 'Agriculture' },
			{ label: 'Forestry', value: 'Forestry' },
			{ label: 'Retail', value: 'Retail' },
			{ label: 'Political Science', value: 'Political Science' },
			{ label: 'Film', value: 'Film' },
			{ label: 'STEM', value: 'STEM' },
			{ label: 'Financial Need Based vs Non Financial Need Based', value: 'Financial Need Based vs Non Financial Need Based' },
			{ label: 'Education', value: 'Education' },
			{ label: 'Military', value: 'Military' },
			{ label: 'State Specific Scholarships', value: 'State Specific Scholarships' },
			{ label: 'Minority', value: 'Minority' },
			{ label: 'Religious', value: 'Religious' },
			{ label: 'Local Scholarship', value: 'Local Scholarship' },
			{ label: 'National Scholarship', value: 'National Scholarship' },
			{ label: 'Graduate Degree', value: 'Graduate Degree' },
			{ label: 'Undergraduate Degree', value: 'Undergraduate Degree' },
			{ label: 'Graduate', value: 'Graduate' },
			{ label: 'Diversity', value: 'Diversity' },
			{ label: 'Merit Based vs Non Merit Based', value: 'Merit Based vs Non Merit Based' },
			{ label: 'Engineering', value: 'Engineering' },
			{ label: 'Natural Science', value: 'Natural Science' },
			{ label: 'Nursing', value: 'Nursing' },
			{ label: 'Liberal Arts', value: 'Liberal Arts' },
			{ label: 'Law', value: 'Law' },
			{ label: 'Merit Based vs Non Merit Based', value: 'Merit Based vs Non Merit Based' },
			{ label: 'Academic Achievement', value: 'Academic Achievement' },
			{ label: 'Career Emphasis', value: 'Career Emphasis' },
			{ label: 'Community Involvement', value: 'Community Involvement' },
			{ label: 'Personal Courage', value: 'Personal Courage' },
			{ label: 'Good Citizenship/Character', value: 'Good Citizenship/Character' },
			{ label: 'Writing/Journalism', value: 'Writing/Journalism' },
			{ label: 'Community College, Trade or Vocational School', value: 'Community College, Trade or Vocational School' },
		],
		INTERESTS: [
			{ label: 'Sports', value: 'Sports' },
			{ label: 'Design', value: 'Design' },
		],
		CITIZENSHIP_OPTIONS: [
			{ label: 'Any Citizenship', value: 'Any Citizenship' },
			{ label: 'U.S. Citizens Only', value: 'U.S. Citizens Only' },
		],
		ETHNICITY: [
			{ label: 'White', value: 'White' },
			{ label: 'Asian American', value: 'Asian American' },
		],
		ETHNICITY_ONBORDING: [
			{ label: 'Black or African American', value: 'Black or African American' },
			{ label: 'White, not of Hispanic/Latino origin', value: 'White, not of Hispanic/Latino origin' },
			{ label: 'Unknown/Not given', value: 'Unknown/Not given' },
			{ label: 'Asian', value: 'Asian' },
			{ label: 'American Indian or Alaskan Native', value: 'American Indian or Alaskan Native' },
			{ label: 'Native Hawaiian-Other Pacific Islander', value: 'Native Hawaiian-Other Pacific Islander' },
			{ label: 'Some other race, ethnicity or origin', value: 'Some other race, ethnicity or origin' },
			{ label: 'White', value: 'White' },
			{ label: 'Hispanic, Latino or Spanish Origin', value: 'Hispanic, Latino or Spanish Origin' },
			{ label: 'American Indian or Alaska Native', value: 'American Indian or Alaska Native' },
			{ label: 'Middle Eastern or North African', value: 'Middle Eastern or North African' },
			{ label: 'Pacific Islander', value: 'Pacific Islander' },
			{ label: 'Unknown', value: 'Unknown' },
			{ label: 'Do Not Want to Report', value: 'Do Not Want to Report' },
			{ label: 'Asian American', value: 'Asian American' },
			{ label: 'Prefer Not to Answer', value: 'Prefer Not to Answer' },
			{ label: 'Hispanic, Latino, or Spanish Origin', value: 'Hispanic, Latino, or Spanish Origin' },
			{ label: 'Native American or Alaskan Native', value: 'Native American or Alaskan Native' },
			{ label: 'Some other race, ethnicity, or origin', value: 'Some other race, ethnicity, or origin' },
			{ label: 'Hispanic or Latino', value: 'Hispanic or Latino' },
			{ label: 'Two or More Races', value: 'Two or More Races' }
		],
		GRADE_LEVEL_OPTIONS: [
			{ label: 'Middle School', value: 'Middle School' },
			{ label: 'H.S. Freshman', value: 'H.S. Freshman' },
			{ label: 'H.S. Sophomore', value: 'H.S. Sophomore' },
			{ label: 'H.S. Junior', value: 'H.S. Junior' },
			{ label: 'H.S. Senior', value: 'H.S. Senior' },
			{ label: 'Undergrad', value: 'Undergrad' },
			{ label: 'Graduate', value: 'Graduate' }
		],
		APPLICATION_STATUS: [
			{ label: 'Applicants Notified of Award', value: 'Applicants Notified of Award' },
			{ label: 'Applicants Notified of Interview', value: 'Applicants Notified of Interview' },
			{ label: 'Draft', value: 'Draft' },
			{ label: 'Withdrawn', value: 'Withdrawn' },
			{ label: 'Submitted', value: 'Submitted' },
			{ label: 'Under Eligibility Review', value: 'Eligibility Review' },
			{ label: 'In Review Board', value: 'In Review Board' },
			{ label: 'Review Board Submitted', value: 'Review Board Submitted' },
			{ label: 'Rejected', value: 'Rejected' },
			{ label: 'Winner', value: 'Winner' },
			{ label: 'Ineligible', value: 'Ineligible' },
			{ label: 'Incomplete', value: 'Incomplete' },
			{ label: 'Preliminary Finalist', value: 'Preliminary Finalist' },
			{ label: 'Finalist', value: 'Finalist' },
			{ label: 'Archived', value: 'Archived' },
			{ label: 'Approved', value: 'Approved' },
			{ label: 'Waitlisted', value: 'Waitlisted' },
			{ label: 'Under Review', value: 'Under Review' },
			{ label: 'Interview', value: 'Interview' },
			{ label: 'Selected', value: 'Selected' },
			{ label: 'Not Selected', value: 'Not Selected' },
			{ label: 'Deferred', value: 'Deferred' },
			{ label: 'Past Cycle', value: 'Past Cycle' },
			{ label: 'Complete', value: 'Complete' },
			{ label: 'Shortlist', value: 'Shortlist' },
			{ label: 'Unqualified', value: 'Unqualified' },
			{ label: 'Qualified', value: 'Qualified' },
			{ label: 'Accepted', value: 'Accepted' },
			{ label: 'Alternate', value: 'Alternate' },
			{ label: 'Committee Recommendation', value: 'Committee Recommendation' },
			{ label: 'Pending Contributor Submissions', value: 'Pending Contributor Submissions' }
		],

		GENDER_OPTION: [
			{ label: 'Male', value: 'male' },
			{ label: 'Female', value: "female" },
			{ label: 'Other', value: "Other" },
			{ label: 'Prefer not to respond', value: 'Prefer not to respond' },
			{ label: 'Gender Variant/Non-Conforming', value: 'Gender Variant/Non-Conforming' },
			{ label: 'Transgender Male', value: "Transgender Male" },
			{ label: 'Transgender Female', value: 'Transgender Female' }
		],
		PROGRAM_TYPE: [
			{ label: 'Grant', value: 'Grant' },
			{ label: 'Scholarship', value: 'Scholarship' },
			{label : 'Nomination' , value : 'Nomination'}
		],
		AMOUNT: [
			{ label: 'Up to $500', value: 'Up to $500' },
			{ label: '$500-$1000', value: '$500-$1000' },
			{ label: '$1000-$2500', value: '$1000-$2500' },
			{ label: '$2500-$5000', value: '$2500-$5000' },
			{ label: '$5000 and above', value: '$5000 and above'},

		],
		GPA: [
			{ label: '1.0 - 2.0', value: '1.0 - 2.0' },
			{ label: '2.0 - 3.0', value: '2.0 - 3.0' },
			{ label: '3.0 - 4.0', value: '3.0 - 4.0' },
			{ label: '4.0 and above', value: '4.0 and above' },

		],
		SIDEBAR_TABS: {
			EXPLORE: 'Explore',
			APPLICATIONS: 'Applications',
			SAVED: 'Saved',
			GRADEBOOK: 'Gradebook',
			PROFILE: 'Profile',
			TASKS: 'Tasks',
			MESSAGE: 'Message',
			LOGOUT: 'Logout',
			DISBURSEMENTS: 'Disbursements',
			RESOURCES: 'Resources',
			DONOR: 'Donors',
			SWITCHROLE: 'Switch Role',
			DASHBOARD: 'Active Users',
			ADMINLOGIN: 'Get User Information',
			ADMINGETHEROKUID: 'Get Heroku ID',
			PROMOTEUSER: 'Promote User',
			UPDATERECOMMENDER: 'Update Recommender',
			UPDATEAPPLICATION: 'Update Application',
			USERPASSWORDRESET: 'User Password Reset',
			USERACTIVITIES: 'User Activities',
			CLIENTUSERS: 'Client Users',
			REVIEWBOARDUSERS: 'Review Board Users',
			ANALYTICSDATA: 'Analytics Data',
			LOGINHISTORY: 'Login History',
			EMAILHISTORY: 'Email History',
			DUPLICATECONTACTS: 'Duplicate Contacts',
			FRONTENDTOSALESFORCESYNC: 'Frontend to Salesforce Sync',
			SSODETAILS: 'SSO Details',
			COPYLEAKSSCAN: ' Copyleaks Scan',
			PORTFOLIOPROGRAM: ' Portfolio Program',
			ACHINFO: 'ACH Info',

		},
		PASSION_OPTIONS: passionData(),
		MAJOR_OPTIONS: majorsData(),
		PRIORITY_OPTIONS: [
			{ label: 'High', value: 'High' },
			{ label: 'Normal', value: 'Normal' }
		],
		GPA_RANGE: [0, 4.0],
		AWARD_AMOUNT: [
			// { label: 'No Minimum', value: 0 },
			{ label: '$1,000 +', value: 1000 },
			{ label: '$5,000 +', value: 5000 },
			{ label: '$10,000 +', value: 10000 },
		]
	},
	SCORECARDS: {
		DESCRIPTION_CHAR_LIMIT: 400
	},
	SSO_ERROR: 'We are facing some issues to authenticate you via SAML, Please try again later.',
	GOOGLE_AUTH_ERROR: 'We are facing some issues to authenticate you via google, Please try again later.',
	DEFAULT_ERROR: "Please fill-out required field.",
	ALLOWED_TAGS:[ 'img','style',"center","head","strong","footer","em","a"],
	ALLOWED_ATTRIBUTES_FOR_REST:['style', "align", "border", "cellpadding", "cellspacing", "id","tilte",'href', 'align', 'alt', 'center', 'bgcolor',"class"],
	ALLOWED_ATTRIBUTES_FOR_IMG:['src', 'alt', 'title', 'width', 'height'],
	ALLOWED_ATTRIBUTES_FOR_ANCHOR:['href', 'name', 'target','src'],
	ALLOWED_SCHEMES:['https','http','data','mailto'],
	ALLOWED_SCHEMES_FOR_IMG: ['https','data'],
	ALLOWED_SCHEMES_FOR_ANCHOR: ['https','http','mailto'],
	ALLOWED_ATTRIBUTES_FOR_IFRAME:['src','width','height','title','frameborder','allow','allowfullscreen'],
	ALLOWED_HOSTNAMES_FOR_IFRAME:['www.youtube.com'],
	FIELD_TYPES_CHECK:['text','textarea','email'],
	DATA_TYPES: {
		"Text": 'text',
		"Long Text": 'textarea',
		"Dropdown": 'select',
		"Picklist": 'select',
		'Number': 'number',
		'Email': 'email',
		'Currency': 'money',
		'Date': 'Date',
		'Date(Month-Year)': 'Date(Month-Year)',
		'Date(Year)': 'Date(Year)',
		'Date(Date-Month-Year)': 'Date(Date-Month-Year)',
		'Date(Month-Date-Year)': 'Date(Month-Date-Year)',
		'Percent': 'number',
		'Output Message': 'Output Message',
		"Radio Button": 'Radio Button',
		'Checkbox': 'Checkbox',
		'Phone': 'phone',
		'Signature': 'signature',
		'Signature With Timestamp': 'signature with timestamp',
		'Document': 'Document',
		'Video': 'Document',
		'Dependent Picklist': 'select',
		'Answer Dependent Picklist': 'select',
		'Multiselect Picklist': 'multiselect',
		'Hover Dependent Picklist': 'Hover Dependent Picklist',
		"Agreement PopUp": "Agreement PopUp",
		"Docusign": "Docusign",
		"Esign": "Esign",
		"Audio": "Document",
		"Encrypted Number":'encrypted number'
	},
	DATA_TYPES_DOC: {
		'Document': 'Document',
		'Video': 'Document',
		'Audio': 'Document'
	},
	FIELD_TYPES: {
		SHORT_ANSWER: 'Text',
		MULTIPLE_CHOICE: 'Multiselect Picklist',
		ESSAY: 'Long Text',
		DROP_DOWN: 'Dropdown',
		RATING: 'Number',
		DOCUMENT: 'Document',
		YES_NO: 'Radio Button',
		GPA: 'Number'
	},
	HEADER: {
		LINKS: [
			{ label: 'Award Programs', url: '' },
			{ label: 'For Sponsor', url: 'https://www.mykaleidoscope.com/for-sponsors' },
			{ label: 'Careers', url: 'https://www.linkedin.com/jobs/search/?f_C=10845923&geoId=92000000' },
			{ label: 'Help Center', url: 'http://help.mykaleidoscope.com' },
		]
	},
	RESUME_STATUS: ['Draft', 'Prototype', "Rejected", "Waitlisted", "Not Selected", "Deferred", "Withdrawn", "Submitted", "Ineligible", "Applicants Notified of Award", "Approved", "Complete", "Finalist", "In Review Board", "Past Cycle", "Preliminary Finalist", "Review Board Submitted", "Selected", "Shortlist", "Under Eligibility Review", "Winner", "Applicants Notified of Interview", "Awarded Stage", "Decline", "Declined", "Declined Stage", "Early Eligibility Review", "Eligible Applicant Pool", "General Eligibility Review", "Incomplete", "Ineligible Stage", "Interview", "Interview Stage", "Not Renewed", "Paid", "Rejected Award", "Renewed", "Sent", "Sent with Tracking", "Withdrawn Stage", "Unqualified", "Pending Client Action", "Qualified", "Accepted", "Alternate", "Committee Recommendation"],
	FOOTER: {
		HEADING: 'Kaleidoscope pairs education dreams with scholarship funding.',
		TOP_LINKS: [
			{ label: 'Award Programs', url: '/', type: '_self' },
			{ label: 'Help Center', url: 'http://help.mykaleidoscope.com', type: '_blank' },
			{ label: 'For Sponsor', url: 'https://www.mykaleidoscope.com/for-sponsors', type: '_blank' },
			{ label: 'Careers', url: 'https://mykaleidoscope.applytojob.com/apply/', type: '_blank' }
		],
		BOTTOM_LINKS: [
			{ label: 'About Us', url: 'https://www.mykaleidoscope.com/about-us' },
			{ label: 'Press', url: 'https://www.mykaleidoscope.com/press' },
			{ label: 'Contact Us', url: 'https://www.mykaleidoscope.com/schedule_demo' },
			{ label: 'Help', url: 'http://help.mykaleidoscope.com' },
			{ label: 'Privacy', url: 'https://www.mykaleidoscope.com/privacy-policy' },
			{ label: 'Terms of Use', url: 'https://www.mykaleidoscope.com/terms-of-use' }
		],
		SOCIAL_LINKS: {
			// TODO: Update links below with social URLS
			facebook: 'https://www.facebook.com/mykscope',
			twitter: 'https://twitter.com/mykscope?lang=en',
			linkedin: 'https://www.linkedin.com/company/10845923',
			instagram: ''
		}
	},
	OPERATORS: [
		{ label: "Contains", value: "contains" },
		{ label: "Is equal to", value: "is_equal_to" },
		{ label: "Is not equal to", value: "is_not_equal_to" },
		{ label: "Is greater than", value: "is_greater_than" },
		{ label: "Is greater than equal to", value: "is_greater_than_equal" },
		{ label: "Is less than", value: "is_less_than" },
		{ label: "Is less than equal to", value: "is_less_than_equal" },
	],
	WARCHDEMOVIDEOURL: {
		The_Basics: 'https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/dbj7igdpgdj5hwclyeos.mp4',
		Eligibility_Rules: 'https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/bh6dzhdd5cgk7cuyieoe.mp4',
		Application_Pages: 'https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/mve284e7bl83fq1txub1.mp4',
		Recommendation_Request: 'https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/tptm5g0mwkqchptjk85o.mp4',
		Review_Process: 'https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/ta4iwhe5iint12i1evh7.mp4'
	},
	STATIC_IMAGE_URL : {
		Mobile_Friendly : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/krjiy2k3k9bc0qpcy4gb.png",
		Donation_Marketplace : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/zzinyqgv04lzcra7pzim.png",
		Fundraising_Made_Easy : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/t3007nqcv9himutlxwd0.png",
		Seamless_Experience : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/vam2kdu5lvwne494a6bg.png",
		Improve_Engagement : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/iwv4ztvfuwhfhxclvmkq.png",
		Unified_Experience : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/zs2owolyxo9t3dkhetf6.png",
		Campaign_Builder : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/qjhtaod53ipkxqt9lpkd.png",
		Disbursement_Static_Page : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/rp6gouf2u69jpnznkk2t.png",
		Success_Icon : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/SuccessIcon-52230.png",
		Marketplace_Icon : "https://mykldexportsprod.blob.core.windows.net/userreports/imports/classic/MarketPlaceIcon-32443.png",
	}
};